/**
 * Срочность отсчета фаз лобби (баны фракций, выбор фракции перед автостартом).
 *
 * Последние секунды подсвечиваются так же, как таймер хода в матче: с 10 с
 * отсчет красный и пульсирует, с 4 с — мигает, и у того, кому еще надо
 * действовать, звучит таймер (тот же звук и тот же порог, что у хода, —
 * TIME_REMAINING_FOR_TIMER_SOUND_SEC в CompletePhaseButton).
 */
export const LOBBY_COUNTDOWN_WARNING_SEC = 10;
export const LOBBY_COUNTDOWN_CRITICAL_SEC = 4;

export const LOBBY_COUNTDOWN_URGENCY = {
  CALM: 'calm',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

/**
 * @param {number|null} seconds - остаток отсчета в секундах (null — отсчета нет)
 * @returns {string} значение LOBBY_COUNTDOWN_URGENCY
 */
export const getLobbyCountdownUrgency = (seconds) => {
  if (seconds === null || seconds === undefined || seconds <= 0) {
    return LOBBY_COUNTDOWN_URGENCY.CALM;
  }
  if (seconds <= LOBBY_COUNTDOWN_CRITICAL_SEC) {
    return LOBBY_COUNTDOWN_URGENCY.CRITICAL;
  }
  if (seconds <= LOBBY_COUNTDOWN_WARNING_SEC) {
    return LOBBY_COUNTDOWN_URGENCY.WARNING;
  }
  return LOBBY_COUNTDOWN_URGENCY.CALM;
};
